'use client';

import { useCallback } from 'react';
import Link from 'next/link';
import { convertObjectToQueryParam } from 'utils/misc';
import { IconClose } from '@sympla/sympla-components';
import locationStore from 'stores/LocationStore';
import { Location } from 'location';
import { useLastSearches } from 'hooks/useLastSearches';
import { createLinkToRedirect } from 'utils/createLinkToRedirect';
import { analytics, analyticsEvents, transportMethods } from 'lib/analytics';
import * as styles from './RecentSearches.css';

const generateSearchLink = (text: string, userLocation: Location) => {
  const query = convertObjectToQueryParam({ s: text });
  return createLinkToRedirect({
    param: query,
    routeType: 'search-bar-default-filter',
    userLocation
  });
};

function RecentSearches({
  hasMossColor,
  onClose,
  setInputValue
}: {
  hasMossColor: boolean;
  onClose?: () => void;
  setInputValue?: (value: string) => void;
}) {
  const { updateLastSearches, lastSearches, removeLastSearch } =
    useLastSearches();

  const userLocation = locationStore.selectedLocation;

  const handleRemoveSearch = (text: string) => {
    removeLastSearch(text);
  };

  const handleUpdateLastSearches = (text: string) => {
    updateLastSearches(text);
  };

  const currentLinkStyle = `${styles.linkStyle} ${
    hasMossColor ? styles.linkStyleMoss : ''
  }`;

  const currentIconStyle = `${styles.iconStyle} ${
    hasMossColor ? styles.iconStyleMoss : ''
  }`;

  const handleClickSearch = useCallback(
    (text: string) => {
      handleUpdateLastSearches(text);
      analytics.sendEvent(analyticsEvents.search_recommended_clicked, {
        search_recommendation_recents_searchs_clicked: text,
        transport: transportMethods.sendBeacon
      });
      if (setInputValue) setInputValue(text);
      if (onClose) onClose();
    },
    [setInputValue, onClose]
  );

  const lastSearchesItems = lastSearches?.map((text) => {
    return (
      <li key={text} className={styles.searchItem}>
        <Link
          onClick={() => handleClickSearch(text)}
          className={currentLinkStyle}
          href={generateSearchLink(text, userLocation)}
        >
          {text}
        </Link>

        <IconClose
          width={16}
          height={16}
          className={currentIconStyle}
          onClick={() => {
            handleRemoveSearch(text);
          }}
        />
      </li>
    );
  });

  return (
    lastSearches &&
    lastSearches.length > 0 && (
      <div className={styles.lastSearchesContainer}>
        <h3 className={styles.sectionTitle}>Busca recente</h3>
        <ul className={styles.lastSearchItems}>{lastSearchesItems}</ul>
      </div>
    )
  );
}

export default RecentSearches;
